/**
 * BRAND CONFIGURATION — Single Source of Truth
 * ============================================
 *
 * Every brand-specific display string, contact detail, operational default,
 * asset URL and colour visible on the public site, login screens, store
 * portal and admin console is driven from THIS file (imported as `BRAND`).
 *
 * To rebrand: edit the VALUES only (never the field names), mirror meta tags in
 * `frontend/public/index.html`, and set BRAND_* / CORS_ORIGINS in backend/.env.
 *
 * Do NOT rename CSS class names (`kazo-text-burgundy`, etc.) or the
 * `--kazo-*` CSS variables — they are stable selectors used across 50+
 * components. Only the underlying colour VALUES (below) change per brand.
 */

export const BRAND = {
  // -- Identity --------------------------------------------------------
  name: "NEW U",                         // Short display name (text fallback / alt)
  legalName: "New U",                    // Used in © footer
  domain: "newu.in",                     // Public-facing website
  shortDescriptor:
    "beauty, cosmetics & wellness retail chain (makeup, skincare, haircare, fragrances, personal grooming; Indian + international brands)",
  logoUrl: "/newu-logo.png",             // colour logo (magenta "new" + gold "U")
  logoOnDarkUrl: "/newu-logo.png",       // colour logo reads well on the dark role too
  logoFooterUrl: "/newu-logo-footer.png",// "new U · A Dabur Enterprise" lock-up for dark footers

  // -- Platform identity (Fundle = the loyalty engine running this app)
  platform: "Fundle",
  poweredBy: "Powered by Fundle",
  aiAssistant: "Fundle Brain",
  platformLogoUrl: "/fundle-logo.png",

  // -- Loyalty programme branding -------------------------------------
  loyaltyProgramName: "New U Rewards",
  welcomePointsValue: 100,
  welcomeToast: "Welcome to New U Rewards! 100 bonus points credited.",
  ctaJoinFree: "Join New U Rewards Free",

  // -- Social --------------------------------------------------------
  social: {
    instagram: "https://instagram.com/newu_dabur",
    facebook: "https://facebook.com/DaburNewU",
    twitter: "https://twitter.com/newu_dabur",
    youtube: "https://youtube.com/channel/UCBfCRQMkBqYHQ97g8El6p2w",
  },

  // -- SEO / meta (also mirror in frontend/public/index.html) ---------
  meta: {
    title: "New U Rewards — Beauty that rewards you | Powered by Fundle",
    description:
      "Join New U Rewards — earn points on every skincare, makeup, haircare and fragrance purchase at New U stores across India. Tier privileges, birthday treats and member-only beauty offers. Powered by Fundle.",
  },

  // -- Public home copy (CMS overrides take precedence at runtime) ----
  homeCopy: {
    heroEyebrow: "New U Rewards · Powered by Fundle",
    heroSubtext:
      "Every serum, lipstick and fragrance you love earns you points. Unlock Glow, Radiance and Luxe privileges, birthday treats and first access to new beauty launches.",
    heroImageAlt: "New U beauty — radiant skin with a skincare serum",
    boutiqueImageAlt: "Inside a New U beauty store — skincare, makeup and fragrance shelves",
    editorialImageAlt: "New U makeup, fragrance and skincare flat lay",
  },

  // -- Footer copy ----------------------------------------------------
  footerTagline:
    "New U Rewards — the loyalty programme for beauty-loving shoppers across India. Earn on skincare, makeup, haircare and fragrance, and let your beauty routine reward you.",

  // -- Login / portal copy --------------------------------------------
  loginCopy: {
    descriptor:
      "Loyalty, CRM, analytics and campaigns for New U — the beauty, cosmetics & fragrance destination.",
    imageAlt: "New U beauty portrait",
    headline: "Beauty,",
    headlineEm: "beautifully run.",
  },

  // -- Public-site contact / legal (legal entity & head office: TODO from owner) -
  audienceDescriptor: "beauty-loving shoppers across India",
  region: "India",
  storeCountLine: "New U stores across India",
  legalEntity: "[TODO: New U legal entity name]",
  headOffice: "[TODO: New U head office address]",
  supportEmail: "customercare@newu.in",
  supportPhone: "7428988625",
  supportPhoneTel: "+917428988625",

  // -- Operational defaults (admin console) ---------------------------
  couponPrefix: "NEWU",
  posMerchantId: "NEWU_FUNDLE",
  sms: {
    senderId: "",             // filled when New U DLT headers are registered
    campaignSenderId: "",
    campaignAccount: "",
  },

  // -- Brand colour palette (VALUES only; names map to --kazo-* vars) --
  // burgundy role = New U magenta (accents); burgundyDeep = AA-contrast magenta used
  // for text and white-text fills (5.6:1 on white). champagne role = New U gold.
  colors: {
    black: "#232323",
    cream: "#FFF8FB",
    burgundy: "#EC008C",
    burgundyDeep: "#C8007A",
    champagne: "#E1A626",
    champagneLight: "#F3D58A",
  },
};

export default BRAND;
